import { render, staticRenderFns } from "./home2025.vue?vue&type=template&id=813495a2&scoped=true"
import script from "./home2025.vue?vue&type=script&lang=js"
export * from "./home2025.vue?vue&type=script&lang=js"
import style0 from "./home2025.vue?vue&type=style&index=0&id=813495a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813495a2",
  null
  
)

export default component.exports